import { Timeout } from 'src/types';

export function throttle<F extends (...args: any[]) => any>(
  f: F,
  delayMs: number,
): (...args: Parameters<F>) => Promise<ReturnType<F> | void> {
  let timeout: Timeout | undefined;

  return async (...args: Parameters<F>): Promise<ReturnType<F> | void> => {
    if (timeout) return;

    return new Promise<ReturnType<F>>(resolve => {
      timeout = setTimeout(() => {
        const returnValue = f(...args) as ReturnType<F>;
        resolve(returnValue);

        clearTimeout(timeout);
        timeout = undefined;
      }, delayMs);
    });
  };
}
